import { Badge, cn } from '@yeshuman/sdk'

import type { ScorecardRecommendation } from '../../hooks/use-interview-kits'
import { scorecardTargetsMet } from '../../lib/scorecard'

const RECOMMENDATION_VARIANT: Record<
  ScorecardRecommendation,
  'defaultSoft' | 'secondarySoft' | 'destructiveSoft'
> = {
  advance: 'defaultSoft',
  hold: 'secondarySoft',
  reject: 'destructiveSoft',
}

export type ScorecardSummaryLineProps = {
  recommendation: ScorecardRecommendation
  recommendationLabel: string
  interviewerName?: string | null
  /** Either the ratings, or precomputed target counts (recruiter summary). */
  ratings?: { level: number | null; target_level: number | null }[]
  metTarget?: number
  rated?: number
  className?: string
}

/** "Advance · meets 3 of 5 targets · Sam": an interviewer's verdict in one line. */
export function ScorecardSummaryLine({
  recommendation,
  recommendationLabel,
  interviewerName,
  ratings,
  metTarget,
  rated,
  className,
}: ScorecardSummaryLineProps) {
  const targets = ratings
    ? scorecardTargetsMet(ratings)
    : { met: metTarget ?? 0, total: rated ?? 0 }
  return (
    <div className={cn('flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground', className)}>
      <Badge variant={RECOMMENDATION_VARIANT[recommendation]}>{recommendationLabel}</Badge>
      {targets.total > 0 ? (
        <span>
          meets {targets.met} of {targets.total} targets
        </span>
      ) : null}
      {interviewerName ? <span>· {interviewerName}</span> : null}
    </div>
  )
}
